import React, { useEffect } from "react";
import "./App.css";
import {  Routes, Route, useLocation } from "react-router-dom";

import Home from "./pages/Home";
import Login from "./pages/Login";
import LoginExpert from "./pages/LoginExpert";
import RegisterExpert from "./pages/RegisterExpert";
import LoginUser from "./pages/LoginUser";
import RegisterUser from "./pages/RegisterUser";
import Contact from "./pages/Contact";

import AccountingAudit from "./pages/AccountingAudit";
import WealthManagement from "./pages/WealthManagement";
import PayrollManagement from "./pages/PayrollManagement";
import BusinessLaw from "./pages/BusinessLaw";
import BusinessCreation from "./pages/BusinessCreation";
import LegalConsulting from "./pages/LegalConsulting";

import BusinessCreationForm from "./pages/BusinessCreationForm";
import ProjectDevelopment from "./pages/ProjectDevelopment";
import Audit from "./pages/Audit";
import ITSecuritySolutions from "./pages/ITSecuritySolutions";
import DirectorProfileModal from "./pages/DirectorProfileModal";
import ControleGestion from "./pages/ControleGestion";
import ConsolidationComptes from "./pages/ConsolidationComptes";
import ConseilStrategie from "./pages/ConseilStrategie";
import CorporateFinance from "./pages/CorporateFinance";
import RSEDeveloppementDurable from "./pages/RSEDeveloppementDurable";
import MecaniqueTransformation from "./pages/MecaniqueTransformation";
import BatimentTravauxPublics from "./pages/BatimentTravauxPublics";
import AdministrationPublique from "./pages/AdministrationPublique";
import ProfessionLiberale from "./pages/ProfessionLiberale";
import AssociationsONG from "./pages/AssociationsONG";
import SocieteCooperative from "./pages/SocieteCooperative";
import EtablissementScolaire from "./pages/EtablissementScolaire";
import ProjetsDeveloppement from "./pages/ProjetsDeveloppement";
import HotellerieRestauration from "./pages/HotellerieRestauration";
import ArtCultureDivertissement from "./pages/ArtCultureDivertissement";
import PrimoEntrepreneurs from "./pages/PrimoEntrepreneurs";
import Immobilier from "./pages/Immobilier";
import Startup from "./pages/Startup";
import IndustrieAgricole from "./pages/IndustrieAgricole";
import CinefEc from "./pages/CinefEc";
import Expertises from "./pages/Expertises";
import CreateursRepreneurs from "./pages/CreateursRepreneurs";
import EntrepreneursPage from "./pages/EntrepreneursPage";
import PmeEtiGrandesEntreprises from "./pages/PmeEtiGrandesEntreprises";
import Actualites from "./pages/Actualites";
import Blog from "./pages/Blog";
import Evenements from "./pages/Evenements";
import DetailActu from "./pages/DetailActu";
import DetailEvent from "./pages/DetailEvent";
import ConditionsUtilisation from "./pages/ConditionsUtilisation";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import DetailBlog from "./pages/DetailBlog";
import CommerceGeneral from './pages/CommerceGeneral';
import BanqueFinance from "./pages/BanqueFinance";
import ConditionsVente from "./pages/ConditionsVente";
import DetailBlog1 from "./pages/DetailBlog1";
import DetailBlog2 from "./pages/DetailBlog2";
import DetailActu1 from "./pages/DetailActu1";
import DetailActu2 from "./pages/DetailActu2";
import DetailActu3 from "./pages/DetailActu3";
import DetailActu4 from "./pages/DetailActu4";
import DetailActu5 from "./pages/DetailActu5";
import DetailBlog3 from "./pages/DetailBlog3";
import DetailBlog4 from "./pages/DetailBlog4";
import Echeances from './pages/Echeances';
import Echanges from './pages/Echanges';
import Messagerie from './pages/Messagerie';
import MonthlyData from './pages/MonthlyData';
import Perfomancly from './pages/Perfomancly';
import Tresorerie from './pages/Tresorerie';
import FinancialStructure from './pages/FinancialStructure';
import Immobilisations from './pages/Immobilisations';
import FiscalData from './pages/FiscalData';
import DetailBlog5 from "./pages/DetailBlog5";
import DetailBlog7 from "./pages/DetailBlog7";
import DetailBlog8 from "./pages/DetailBlog8";
import DetailBlog9 from "./pages/DetailBlog9";
import DetailBlog6 from "./pages/DetailBlog6";
import DetailBlog10 from "./pages/DetailBlog10";
import DetailBlog11 from "./pages/DetailBlog11";
import DetailBlog12 from "./pages/DetailBlog12";
import DetailBlog13 from "./pages/DetailBlog13";
import DetailBlog14 from "./pages/DetailBlog14";
import ForgotPassword from "./pages/ForgotPassword";
import EcheancesComptable from "./pages/EcheancesComptable";
import EchangesFichiersComptable from "./pages/EchangesFichiersComptable";
import MessagerieComptable from './pages/MessagerieComptable'
import MonthlyDataComptable from "./pages/MonthlyDataComptable";
import CreateClient from "./pages/CreateClient";
import NotificationsComptable from "./pages/NotificationsComptable";
import SettingComptable from "./pages/SettingComptable";
import Setting from "./pages/Setting";
import Notifications from "./pages/Notifications"
import ListeClients from "./pages/ListeClients";
import ModifierClients from "./pages/ModifierClients";
import ProtectedRoute from "./components/ProtectedRoute";
import AuthDemo from "./pages/AuthDemo";


// Composant ScrollToTop
function ScrollToTop() {
  const { pathname } = useLocation();

   useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // change en "smooth" si tu veux un scroll doux
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
      <>
      <ScrollToTop />
      <Routes>
        {/* Pages principales */}
        <Route path="/" element={<Home />} />
        <Route path="/cinef-ec" element={<CinefEc />} />
        <Route path="/login" element={<Login />} />
        <Route path="/loginexpert" element={<LoginExpert />} />
        <Route path="/registerexpert" element={<RegisterExpert />} />
        <Route path="/loginuser" element={<LoginUser />} />
        <Route path="/registeruser" element={<RegisterUser />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/auth-demo" element={<AuthDemo />} />
        <Route path="/expertises" element={<Expertises />} />
        <Route path="/businesscreationform" element={<BusinessCreationForm />} />
        <Route path="/mecaniques-et-transformations" element={<MecaniqueTransformation />} />
        <Route path="/batiments-et-travaux-publics" element={<BatimentTravauxPublics />} />
        <Route path="/administration-publique" element={<AdministrationPublique />} />
        <Route path="/profession-liberale" element={<ProfessionLiberale />} />
        <Route path="/association-ong-fondations" element={<AssociationsONG />} />
        <Route path="/societe-cooperative" element={<SocieteCooperative />} />
        <Route path="/etablissement-scolaire" element={<EtablissementScolaire />} />
        <Route path="/projets-developpement" element={<ProjetsDeveloppement />} />
        <Route path="/hotellerie-restauration" element={<HotellerieRestauration />} />
        <Route path="/art-culture-divertissement" element={<ArtCultureDivertissement />} />
        <Route path="/primo-entrepreneurs" element={<PrimoEntrepreneurs />} />
        <Route path="/immobilier" element={<Immobilier />} />
        <Route path="/startup" element={<Startup />} />
        <Route path="/industrie-agricole" element={<IndustrieAgricole />} />
        <Route path="/createur-repreneurs" element={<CreateursRepreneurs/>} />
        <Route path="/entrepreneurs" element={<EntrepreneursPage/>} />
        <Route path="/pme-eti" element={<PmeEtiGrandesEntreprises/>} />
        <Route path="/actualites" element={<Actualites/>} />
        <Route path="/actualites/blog" element={<Blog/>} />
        <Route path="/actualites/events" element={<Evenements/>} />
        <Route path="/actualites/1" element={<DetailActu/>} />
        <Route path="/actualites/2" element={<DetailActu1/>} />
        <Route path="/actualites/3" element={<DetailActu2/>} />
        <Route path="/actualites/4" element={<DetailActu3/>} />
        <Route path="/actualites/5" element={<DetailActu4/>} />
        <Route path="/actualites/6" element={<DetailActu5/>} />
        <Route path="/evenements/1" element={<DetailEvent/>} />
        <Route path="/terms" element={<ConditionsUtilisation/>} />
        <Route path="/privacy" element={<PolitiqueConfidentialite/>} />
        <Route path="/blog/1" element={<DetailBlog/>} />
        <Route path="/blog/2" element={<DetailBlog1/>} />
        <Route path="/blog/3" element={<DetailBlog2/>} />
        <Route path="/blog/4" element={<DetailBlog3/>} />
        <Route path="/blog/5" element={<DetailBlog4/>} />
        <Route path="/blog/6" element={<DetailBlog5/>} />
        <Route path="/blog/7" element={<DetailBlog6/>} />
        <Route path="/blog/8" element={<DetailBlog7/>} />
        <Route path="/blog/9" element={<DetailBlog8/>} />
        <Route path="/blog/10" element={<DetailBlog9/>} />
        <Route path="/blog/11" element={<DetailBlog10/>} />
        <Route path="/blog/12" element={<DetailBlog11/>} />
        <Route path="/blog/13" element={<DetailBlog12/>} />
        <Route path="/blog/14" element={<DetailBlog13/>} />
        <Route path="/blog/15" element={<DetailBlog14/>} />
        
        <Route path="/commerce" element={<CommerceGeneral/>} />
        <Route path="/banques-finances" element={<BanqueFinance/>} /> 
        
        
        <Route path="/services/comptabilite-fiscalite" element={<AccountingAudit />} />
        <Route path="/services/gestion-patrimoine" element={<WealthManagement />} />
        <Route path="/services/paie-gestion-salaries" element={<PayrollManagement />} />
        <Route path="/services/droit-affaires-contentieux" element={<BusinessLaw />} />
        <Route path="/services/creation-transformation-entreprise" element={<BusinessCreation />} />
        <Route path="/services/conseils-accompagnement-juridique" element={<LegalConsulting />} />
        <Route path="/services/solutions-informatiques-securite" element={<ITSecuritySolutions />} />
        <Route path="/services/montage-projets-business-plan" element={<ProjectDevelopment />} />
        <Route path="/services/audit" element={<Audit />} />
        <Route path="/services/controle-gestion" element={<ControleGestion />} />
        <Route path="/services/consolidation-comptes" element={<ConsolidationComptes />} />
        <Route path="/services/conseil-strategie-entreprise" element={<ConseilStrategie />} />
        <Route path="/services/corporate-finance" element={<CorporateFinance />} />
        <Route path="/services/rse-developpement-durable" element={<RSEDeveloppementDurable />} />
        <Route path="/services/banques-finances" element={<BanqueFinance />} />
        <Route path="/biography" element={<DirectorProfileModal />} />
        <Route path="/security" element={<ConditionsVente />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/notifications" element={<NotificationsComptable />} />
        <Route path="/parametres" element={<SettingComptable />} />
        <Route path="/settings" element={<Setting />} />
        <Route path="/notify" element={<Notifications />} />

        {/* ROUTES DU TABLEAU DE BORD DE CINEF-EC Client*/}
        <Route path="/dashboard-user/echeances" element={
          <ProtectedRoute requiredUserType="client">
            <Echeances/>
          </ProtectedRoute>
        } />
        <Route path="/dashboard-user/fichiers" element={
          <ProtectedRoute requiredUserType="client">
            <Echanges/>
          </ProtectedRoute>
        } />
        <Route path="/dashboard-user/messagerie" element={
          <ProtectedRoute requiredUserType="client">
            <Messagerie/>
          </ProtectedRoute>
        } />
        <Route path="/donnees-mensuelles" element={
          <ProtectedRoute requiredUserType="client">
            <MonthlyData/>
          </ProtectedRoute>
        } />
        <Route path="/donnees-annuelles/performances" element={
          <ProtectedRoute requiredUserType="client">
            <Perfomancly/>
          </ProtectedRoute>
        } />
        <Route path="/donnees-annuelles/tresorerie" element={
          <ProtectedRoute requiredUserType="client">
            <Tresorerie/>
          </ProtectedRoute>
        } />
        <Route path="/donnees-annuelles/structure-financiere" element={
          <ProtectedRoute requiredUserType="client">
            <FinancialStructure/>
          </ProtectedRoute>
        } />
        <Route path="/donnees-annuelles/immobilisations" element={
          <ProtectedRoute requiredUserType="client">
            <Immobilisations/>
          </ProtectedRoute>
        } />
        <Route path="/donnees-annuelles/fiscal-social" element={
          <ProtectedRoute requiredUserType="client">
            <FiscalData/>
          </ProtectedRoute>
        } />

        {/* ROUTES DU TABLEAU DE BORD DE CINEF-EC Comptable*/}
        <Route path="/dashboard-comptable/echeances" element={
          <ProtectedRoute requiredUserType="expert">
            <EcheancesComptable/>
          </ProtectedRoute>
        } />
        <Route path="/dashboard-comptable/fichiers" element={
          <ProtectedRoute requiredUserType="expert">
            <EchangesFichiersComptable/>
          </ProtectedRoute>
        } />
        <Route path="/dashboard-comptable/messagerie" element={
          <ProtectedRoute requiredUserType="expert">
            <MessagerieComptable/>
          </ProtectedRoute>
        } />
        <Route path="/donnees-mensuellescomptable" element={
          <ProtectedRoute requiredUserType="expert">
            <MonthlyDataComptable/>
          </ProtectedRoute>
        } />
        <Route path="/creer-client" element={
          <ProtectedRoute requiredUserType="expert">
            <CreateClient/>
          </ProtectedRoute>
        } />
        <Route path="/liste-clients" element={
          <ProtectedRoute requiredUserType="expert">
            <ListeClients/>
          </ProtectedRoute>
        } />

        <Route 
          path="/dashboard-comptable/edit-client/:id" 
          element={
            <ProtectedRoute requiredUserType="expert">
              <ModifierClients />
            </ProtectedRoute>
          }
        />
      </Routes>
     </>
  );
}

export default App;
